/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type footer_footer$ref: FragmentReference;
export type footer_footer = {|
  +facebookLink: string,
  +twitterLink: string,
  +instagramLink: string,
  +linkedinLink: string,
  +youtubeLink: string,
  +leftColumn: $ReadOnlyArray<{|
    +title: string,
    +link: {|
      +id: ?string,
      +uid: ?string,
      +type: ?string,
      +slug: ?string,
      +link_type: ?string,
      +url: ?string,
      +target: ?string,
    |},
  |}>,
  +rightColumn: $ReadOnlyArray<{|
    +title: string,
    +link: {|
      +id: ?string,
      +uid: ?string,
      +type: ?string,
      +slug: ?string,
      +link_type: ?string,
      +url: ?string,
      +target: ?string,
    |},
  |}>,
  +$refType: footer_footer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "link",
    "storageKey": null,
    "args": null,
    "concreteType": "Link",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "uid",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "slug",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "link_type",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "target",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Fragment",
  "name": "footer_footer",
  "type": "Footer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "facebookLink",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "twitterLink",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "instagramLink",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "linkedinLink",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "youtubeLink",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "leftColumn",
      "storageKey": null,
      "args": null,
      "concreteType": "FooterItem",
      "plural": true,
      "selections": v0
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "rightColumn",
      "storageKey": null,
      "args": null,
      "concreteType": "FooterItem",
      "plural": true,
      "selections": v0
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '331457631d20ac3b331642187244aeff';
module.exports = node;
